// CR-5880: KPI graph milestones (Admin Setup -> Performance -> KPI Milestones).
import api, { type AxiosResponse, type PaginatedResponse } from './client';

/** Which KPI graphs draw a milestone. */
export type MilestoneAppliesTo = 'otif' | 'otd' | 'both';

/** A milestone as the list endpoint returns it. */
export interface KpiMilestone {
  id: number;
  title: string;
  /** ISO date, YYYY-MM-DD. */
  milestone_date: string;
  /** 0 = system default (cannot be deleted), 1 = user-created. */
  milestone_type: number;
  applies_to: MilestoneAppliesTo;
  is_active: boolean;
}

/**
 * A milestone as the dashboard payload carries it — drawn as a dashed vertical
 * line on the OTIF / OTD graphs.
 */
export interface ChartMilestone {
  id: number;
  title: string;
  /** ISO date, YYYY-MM-DD. */
  date: string;
  /** The x-axis value (chart period label) the line sits on. */
  period: string;
  applies_to: MilestoneAppliesTo;
}

/** Fields an administrator sets. */
export interface KpiMilestoneInput {
  title: string;
  milestone_date: string;
  applies_to: MilestoneAppliesTo;
  is_active: boolean;
}

export const milestonesAPI = {
  /** The configuring company's milestones, oldest first. */
  list: (): Promise<AxiosResponse<PaginatedResponse<KpiMilestone> | KpiMilestone[]>> =>
    api.get('/purchasing/milestones/', { params: { page_size: 200 } }),
  create: (data: KpiMilestoneInput): Promise<AxiosResponse<KpiMilestone>> =>
    api.post('/purchasing/milestones/', data),
  update: (id: number, data: Partial<KpiMilestoneInput>): Promise<AxiosResponse<KpiMilestone>> =>
    api.patch(`/purchasing/milestones/${id}/`, data),
  remove: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/purchasing/milestones/${id}/`),
};
